/** `"52.52, 13.40"` → `[lat, lon]`, or undefined when it is not a valid coordinate pair. */
export function parseCenter(s: string | undefined): [number, number] | undefined {
  const m = /^\s*(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*$/.exec(s ?? "");
  if (!m) return undefined;
  const lat = Number(m[1]);
  const lon = Number(m[2]);
  return Math.abs(lat) <= 90 && Math.abs(lon) <= 180 ? [lat, lon] : undefined;
}
